"use client";
import dynamic from "next/dynamic";
import { DatadogInit, UserContextInit } from "../_components/datadog/rum";
import { ThemeProvider } from "@optimization/widgets/ThemeProvider";
import { HeaperInitScript } from "../_components/heaper/HeaperInitScript";
import { HeaperInit } from "../_components/heaper/heaper";
import ApolloProvider from "./apollo-provider";
import FleetGraphqlApiProvider from "./fleet-graphql-api-provider";
import Script from "next/script";

const AuthProvider = dynamic(() => import("./auth-provider"), { ssr: false });
const FeatureFlagProvider = dynamic(() => import("./feature-flag-provider"), {
  ssr: false,
});
const ReactDevTools = () => {
  return (
    process.env.NEXT_PUBLIC_ENVIRONMENT !== "production" && (
      <Script id="react-devtools" src="http://localhost:8097" />
    )
  );
};

export default function Providers({ children }: { children: React.ReactNode }) {
  return (
    <html lang="en">
      <HeaperInitScript />
      <body>
        <ReactDevTools />
        <DatadogInit />
        <ThemeProvider>
          <AuthProvider>
            <FeatureFlagProvider>
              <FleetGraphqlApiProvider>
                <ApolloProvider>
                  <>
                    <HeaperInit />
                    <UserContextInit />
                    {children}
                  </>
                </ApolloProvider>
              </FleetGraphqlApiProvider>
            </FeatureFlagProvider>
          </AuthProvider>
        </ThemeProvider>
      </body>
    </html>
  );
}
